import slugs from "navigation/slugs";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "utils/number/number";
import { ComingSoon, Loading } from "components/commons";
import { ReactComponent as Checklist } from "assets/icons/checklist.svg";

import {
  BellIcon,
  BellSnoozeIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";
import useSWR from "swr";
import {
  getTiktokUserTrendingUsers,
  subscribe,
  unsubscribe,
} from "services/apis/apis";
import { ACCESS_TOKEN, getItem } from "local-storage";
import { useEffect, useState } from "react";

export const Trending = () => {
  const accessToken = getItem(ACCESS_TOKEN) || "";
  const [datas, setDatas] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(0);

  useEffect(() => {
    const f = async () => {
      try {
        setIsLoading(true);
        const accessToken = getItem(ACCESS_TOKEN) || "";
        if (!accessToken) return;
        const result = await getTiktokUserTrendingUsers(accessToken, 20);
        setDatas(result);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
    f();
  }, [refetch]);

  const handleUnsubscribe = async (userId: string, index: number) => {
    try {
      if (!accessToken) return;

      const updatedDatas: any = [...datas];
      updatedDatas[index].isSubscribe = false;
      updatedDatas[index].numFan = updatedDatas[index].numFan - 1;
      setDatas(updatedDatas);

      const result = await unsubscribe(accessToken, userId);

      if (!result) {
        setDatas(datas);
      }

      console.log(result);
    } catch (error) {
      console.log(
        "🚀 ~ file: OtherProfile.tsx:43 ~ handleUnsubscribe ~ error:",
        error
      );
    }
  };

  const handleSubscribe = async (userId: string, index: number) => {
    try {
      if (!accessToken) return;

      const updatedDatas = [...datas];
      updatedDatas[index].isSubscribe = true;
      updatedDatas[index].numFan = updatedDatas[index].numFan + 1;
      setDatas(updatedDatas);

      const result = await subscribe(accessToken, userId);

      if (!result) {
        setDatas(datas);
      }

      console.log(
        "🚀 ~ file: OtherProfile.tsx:218 ~ handleSubscribe ~ result:",
        result
      );
    } catch (error) {
      console.log(
        "🚀 ~ file: OtherProfile.tsx:219 ~ handleSubscribe ~ error:",
        error
      );
    }
  };

  const renderBottomCard = (item: any) => {
    return (
      <>
        <div className="flex justify-between text-xs font-medium px-4 py-2 border-t border-gray-800">
          <div className="flex items-center">
            <div className="flex items-baseline gap-2">
              <span className="uppercase text-slate-500">Holder:</span>
              <span className="text-info font-mono whitespace-nowrap">
                {item?.total_holders || "-"}
              </span>
            </div>
          </div>
          <div className="flex items-baseline gap-2">
            <span className="uppercase text-slate-500">Price:</span>
            <span className="text-secondary font-mono whitespace-nowrap">
              {Number(item?.current_price)
                ? Number(item?.current_price) < 0.0001
                  ? "<0.0001"
                  : "~" + item?.current_price.toFixed(4) + " Ξ"
                : "-"}
            </span>
          </div>
        </div>
        <div className="flex justify-between text-xs font-medium px-4 pb-2">
          <div className="flex items-center">
            <div className="flex items-baseline gap-2">
              <span className="uppercase text-slate-500">Shares:</span>
              <span className="text-info font-mono whitespace-nowrap">
                {item?.total_shares || "-"}
              </span>
            </div>
          </div>
          <div className="flex items-baseline gap-2">
            <span className="uppercase text-slate-500">Total Volume: </span>
            <span className="text-secondary font-mono whitespace-nowrap">
              {Number(item?.total_volume)
                ? item.total_volume.toFixed(4) + " Ξ"
                : " - "}
            </span>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="my-4 text-xl flex justify-between items-center mt-14">
        <div>
          <span className="text-xl">🔥</span> Trending Idols
        </div>
        <ArrowPathIcon
          className="w-6 h-6 p-1"
          onClick={() => setRefetch((i) => i + 1)}
        />{" "}
      </div>
      {isLoading && <Loading />}
      {!datas?.length && !isLoading ? (
        <div className="flex-1 flex flex-col justify-center items-center">
          <ComingSoon
            type="eyes"
            title=""
            des="Trending idols has not been found"
          />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-4 w-full">
            {datas?.map((item: any, idx: number) => {
              return (
                <div
                  className="border-2 rounded-xl border-gray-800"
                  key={idx}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`${slugs.profile}/${item?.id}`);
                  }}
                >
                  <div
                    className={`flex p-4 gap-4 justify-between items-center `}
                  >
                    <div className="flex items-center  gap-3 w-full">
                      <div className="shadow-sm overflow-hidden flex justify-center items-center relative">
                        {item?.metadata?.avatar_168x168 ? (
                          <img
                            className="h-12 w-12 shadow-sm rounded-full object-fill"
                            src={item?.metadata?.avatar_168x168}
                            alt="avatar"
                          />
                        ) : (
                          <i className="fa-duotone fa-user text-2xl text-primary"></i>
                        )}
                        {item?.user_id ? (
                          <Checklist className="w-4 h-4 absolute bottom-0 right-0" />
                        ) : null}
                      </div>

                      <div className="flex-1 flex justify-between">
                        <h6
                          className="flex flex-col items-baseline transition-all"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`${slugs.profile}/${item?.id}`);
                          }}
                        >
                          <span
                            className={`text-base font-normal leading-none mr-1 mb-1`}
                          >
                            {item?.nickname}
                          </span>
                          <span className="text-xs font-normal text-slate-500">
                            {item?.follower_count
                              ? formatNumber(Number(item.follower_count))
                              : "-"}{" "}
                            Followers
                          </span>
                        </h6>
                        {item?.isSubscribe ? (
                          <BellIcon
                            className="w-6 h-6  text-[#1BC57E]"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleUnsubscribe(item.id, idx);
                            }}
                          />
                        ) : (
                          <BellSnoozeIcon
                            className="w-6 h-6"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSubscribe(item.id, idx);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {renderBottomCard(item)}
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};
